export const SIDE_NAV_DRAWER_WIDTH = 240;
